import { useEffect, useState } from "react";
import { AvailabilitiesCollection, setTimes, AvailabitiesBinary } from "../../Utils/TimeSlotUtils";
import { WeekSessionPickerMobileScheduleRow } from "./WeekSessionPickerMobileScheduleRow";

export function WeekSessionPickerMobile({ tutorAvailabilities, availabilities, onChange, classNameCss }: { tutorAvailabilities: AvailabitiesBinary | undefined, availabilities: AvailabitiesBinary | undefined, onChange: (ab: AvailabitiesBinary) => void, classNameCss:string }) {
	const [availableTimes, setAvailableTimes] = useState([] as string[][]);

	useEffect(() => {
		if (tutorAvailabilities) {
			var ac: AvailabilitiesCollection = {
                Binaries: tutorAvailabilities,
                IsAny: {
                    Monday: false,
                    Tuesday: false,
                    Wednesday: false,
                    Thursday: false,
                    Friday: false,
                    Saturday: false,
                    Sunday: false
                }
            };
			const times = setTimes(ac);
			setAvailableTimes(times);
		}
	}, [tutorAvailabilities]);

	function displayAllTimes(times: string[][]) {
		return (
			times.map((day, index) => (
				<WeekSessionPickerMobileScheduleRow key={index} day={day} index={index} availabilities={availabilities ?? {} as AvailabitiesBinary} setAvailabilities={onChange} />
			))
		);
	}

	return (
		<div className={classNameCss} >
			<div className="basic-form-label">
				Available times:
			</div>
			{displayAllTimes(availableTimes)}
		</div>
	);
}

